// MenuConfig.js - Simplified navigation menu
export const MENU_ITEMS = [
  {
    id: 'dashboard',
    icon: 'HomeMenuIcon',
    text: 'Dashboard',
    path: '/dashboard',
    type: 'simple'
  },
  // Governance
  {
    id: 'dataanalyser',
    icon: 'QisMenuIcon',
    text: 'Quality Intelligence Suite',
    path: '/capabilities',
    type: 'simple',
    additionalPaths: ['/data-analyzer-chat', '/data-analyzer', '/data-analyzer-home', '/chat-history']
  },
  {
    id: 'project',
    icon: 'EngineMenuIcon',
    text: 'Engineering Engine',
    path: '/projects',
    type: 'simple',
    additionalPaths: ['/automation-script', '/test-suite', '/project-chat']
  },
  // Organization — flat items (no expandable)
  {
    id: 'settings',
    icon: 'SettingsMenuIcon',
    text: 'Settings',
    path: '/organization-settings',
    type: 'simple'
  },
  {
    id: 'roles-permissions',
    icon: 'RolesMenuIcon',
    text: 'Roles & Permissions',
    path: '/organization-roles-and-permissions',
    type: 'simple'
  },
  {
    id: 'members',
    icon: 'MembersMenuIcon',
    text: 'Members',
    path: '/organization-members',
    type: 'simple'
  },
  // {
  //   id: 'monitoring',
  //   icon: 'MonitoringMenuIcon',
  //   text: 'Monitoring',
  //   path: '/token-usage',
  //   type: 'simple'
  // },
  {
    id: 'register-organisation',
    icon: 'SettingsMenuIcon',
    text: 'Org Onboarding',
    path: '/register-organisation',
    type: 'simple',
    superAdminOnly: true
  }
];